import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_CATEGORIES = "categories";
const BASE_URL = "/api/categories";

const CategoryQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const CATEGORY_EMPTY = {
    title: "",
    fromYear: "",
    toYear: ""

};

export function useCategories() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_CATEGORIES],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...CategoryQueryConfig
    });
    return {...result, categories: result.data};
}


export function useCategory(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_CATEGORIES, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...CategoryQueryConfig
    });
    return {...result, category: result.data};
}

export function useCategoryMutations() {
    async function createFunction(category) {
        if (!category) return;
        return await fetchPOST(BASE_URL, category, false);
    }

    async function editFunction(category) {
        if (!category) return;
        return await fetchPUT(`${BASE_URL}/${category.id}`, category);
    }

    async function editAddNewFiles(category) {
        if (!category) return;
        return await fetchPUT(`${BASE_URL}/${category.id}/files`, category.filesIds);
    }

    async function deleteFunction(category) {
        return await fetchDELETE(`${BASE_URL}/${category.id}`)
    }

    return {
        createCategory: useMyMutation(createFunction, REACT_QUERY_ID_CATEGORIES, category => `Category ${category.title} created`),
        editCategory: useMyMutation(editFunction, REACT_QUERY_ID_CATEGORIES, category => `Category ${category.title} modified`),
        editAddNewFiles: useMyMutation(editAddNewFiles, REACT_QUERY_ID_CATEGORIES, category => `Category ${category.title} modified`),
        deleteCategory: useMyMutation(deleteFunction, REACT_QUERY_ID_CATEGORIES, category => `Category ${category.title} deleted.`)
    };

}